'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArtInstitute = function (_Component) {
  (0, _inherits3.default)(ArtInstitute, _Component);

  function ArtInstitute() {
    (0, _classCallCheck3.default)(this, ArtInstitute);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ArtInstitute).call(this));

    _this.state = {
      isContentScorllShow: false
    };
    return _this;
  }

  (0, _createClass3.default)(ArtInstitute, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'onBtnClickHandler',
    value: function onBtnClickHandler() {
      this.setState({
        isContentScorllShow: !this.state.isContentScorllShow
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ArtInstitute.scss');
      var isContentScorllShow = this.state.isContentScorllShow;

      var headerArray = [{
        text: '全部',
        value: 'ALL'
      }, {
        text: '加入时间',
        value: 'TSGC'
      }];
      return _react2.default.createElement(
        'div',
        { className: styles.cr_component },
        _react2.default.createElement('img', { className: styles.comImg, src: 'http://tupian.goeasy.cn:9999/yipinwang/header/bg_img1.jpg' }),
        _react2.default.createElement(_components.NewHeader, { isNotBack: !!1 }),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'div',
            { className: styles.contentLeft },
            _react2.default.createElement(
              'div',
              { className: styles.erjizs },
              _react2.default.createElement('div', { className: styles.erjiBack }),
              _react2.default.createElement(
                'div',
                { className: styles.erjiContentLeft },
                _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/header/logo_a.png', alt: '' }),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '东阳中国木雕城坐落于“中国木雕之都”--浙江东阳，占地210亩，市场面积41万平方米'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    '东阳中国木雕城自2009年转型升级以来，市场交易繁荣，发展势头强劲，一跃成为国内最大的木质工艺品和木雕（红木）家具批发市场！中国工艺美术学会木雕艺术专业委员会、浙江省木雕红木家具产品质量检验中心、东阳木雕地理证明商标使用办公室等行业权威机构均常驻市场办公。'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    '东阳中国木雕城汇集了包括全国“四大名雕”在内的上千家知名厂家，产品涵盖了木雕、根雕、木雕（红木）家具、仿古门窗、竹编竹雕、木竹工艺旅游纪念品等数万种优势产品。销售网络辐射全国各省、自治区、直销市的二级批发市场以及日本、韩国、东南亚等国家和地区。'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.action_yr_box },
                _react2.default.createElement(
                  'div',
                  { className: styles.action_yr_right },
                  _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/gzz/gzzbg15.jpg', alt: '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.action_yr_left },
                  _react2.default.createElement(
                    'div',
                    { className: styles.yiren },
                    _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/gzz/gzzbg14.jpg', alt: '' }),
                    _react2.default.createElement(
                      'p',
                      null,
                      '钟连盛'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.yiren + ' ' + styles.poa },
                    _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/gzz/gzzbg14.jpg', alt: '' }),
                    _react2.default.createElement(
                      'p',
                      null,
                      '钟连盛'
                    )
                  )
                )
              )
            ),
            isContentScorllShow ? _react2.default.createElement(_components.NewTsqySearchPageComponent, { headerArray: headerArray }) : ''
          ),
          _react2.default.createElement(
            'div',
            { className: styles.contentRight },
            _react2.default.createElement('div', { className: styles.contentRightBlack }),
            _react2.default.createElement(
              'button',
              { onClick: this.onBtnClickHandler.bind(this), type: 'button',
                className: styles.contentBtn + ' ' + (isContentScorllShow ? styles.contentMiss : '') },
              '店铺列表'
            ),
            _react2.default.createElement('img', { onClick: this.onBtnClickHandler.bind(this),
              src: 'http://tupian.goeasy.cn:9999/yipinwang/header/icon-off.png', alt: '',
              className: styles.contentImg + ' ' + (isContentScorllShow ? '' : styles.contentMiss) }),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/workstation', className: styles.contentRightHome },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/header/icon-fanhui.png', alt: '' })
            )
          )
        )
      );
    }
  }]);
  return ArtInstitute;
}(_react.Component);

exports.default = ArtInstitute;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ArtInstitute/ArtInstitute.js
 ** module id = 1438
 ** module chunks = 0
 **/